import { Component, inject } from '@angular/core';
import { ModalController, IonToolbar, IonTitle, IonButton, IonButtons, IonIcon } from '@ionic/angular/standalone';
import { close } from 'ionicons/icons';
import { addIcons } from 'ionicons';
@Component({
    selector: 'app-disclaimer-modal',
    templateUrl: './disclaimer-modal.component.html',
    styleUrls: ['./disclaimer-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonButton, IonButtons, IonIcon]
})
export class DisclaimerModalComponent {
  modalController = inject(ModalController);

  constructor() {
    addIcons({ close });
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
